import type { AppSettings, KnownSettingKey } from "@/shared/lib/db-schema";

// Last-resort defaults if a setting row is missing in DB (cold start /
// not seeded). NOT user-facing constants — the DB is the source of truth;
// these only keep the app renderable before settings load.
export const FALLBACKS: AppSettings = {
  currency: "RUB",
  currency_symbol: "₽",
  app_name: "EUROSTYLE",
  support_handle: "@eurostyle_support",
  support_url: "https://t.me/eurostyle_support",
  tg_channel_url: "https://t.me/eurostyle",
  bot_username: "eurostyle_bot",
  min_order_amount: 0,
  free_shipping_from: 15000,
  delivery_cost: 500,
  contact_phone: "+7 (000) 000-00-00",
  contact_email: "info@eurostyle.ru",
  legal_inn: "0000000000",
  legal_name: "ООО «ЕВРОСТАЙЛ»",
  legal_address: "Москва, ул. Примерная, 1",
  legal_address_geo_lat: null,
  legal_address_geo_lng: null,
  default_locale: "ru",
  promo_badge: "promo",
  hit_badge: "hit",
  new_badge: "new",
  policy_return: "",
  policy_payment: "",
  policy_privacy: "",
  banners_fallback_title: "Новые коллекции каждую неделю",
  banners_fallback_subtitle: "Актуальные новинки каждую неделю",
};

export function getSetting<K extends KnownSettingKey>(
  map: Partial<AppSettings>,
  key: K,
): AppSettings[K] {
  return (map[key] ?? FALLBACKS[key]) as AppSettings[K];
}
